import type { FC } from 'react';
import useSpinner from '@hooks/useSpinner';

import styles from './Spinner.module.scss';

type SpinnerProps = {
  visible?: boolean;
};

const Spinner: FC<SpinnerProps> = ({ visible }) => {
  const { isVisible } = useSpinner()[1];

  if (!isVisible && !visible) return null;

  return (
    <div className={styles.PreloaderContainer}>
      <div className={styles.Preloader}>
        <img
          src="/assets/spinner/spinner.svg"
          alt="loader"
          width={100}
          height={80}
          className={styles.spinner}
        />
      </div>
    </div>
  );
};

export default Spinner;
